import MetricBase from "models/metrics/MetricBase";
import EmptyUnit from "models/metrics/unit/EmptyUnit";
import i18n from "i18next";
import VisibilityGroup from "../../../../groups/VisibilityGroup";

class MetricMissedImprBidBing extends MetricBase {
    constructor() {
        super({
            field: "metric_missed_impr_bid",
            defaultVisibility: true,
            unit: new EmptyUnit(),
            chartName: i18n.t("metrics.bing-hotel-ads.missedImprBid.chartName"),
            serieLabel: i18n.t("metrics.bing-hotel-ads.missedImprBid.serieLabel"),
            tooltip: i18n.t("metrics.bing-hotel-ads.missedImprBid.tooltip"),
            group: new VisibilityGroup(),
        });
    }
}

export default MetricMissedImprBidBing;
